import { RICH_TEXT_NODES, RICH_TEXT_THEME } from '@plato/shared-util/lexical-config';
import {
    RichTextInput as UIRichTextInput,
    type RichTextInputVariant,
    type RichTextValue,
} from '@plato/ui/components/rich-text-input';
import type { ReactElement } from 'react';
import { AutoFocusPlugin } from './auto-focus-plugin.tsx';
import { ToolbarPlugin } from './toolbar-plugin.tsx';

export type { RichTextInputVariant, RichTextValue };

export type RichTextInputProps = {
    disableVoiceRecording?: boolean;
    autoFocus?: boolean;
    value: RichTextValue | undefined;
    onChange: (value: RichTextValue) => void;
    placeholder?: string;
    className?: string;
    contentClassName?: string;
    error?: boolean;
    /**
     * `default`: full border and toolbar always visible.
     * `inline`: bottom-border-only placeholder look when unfocused; full border and
     * toolbar reveal on focus (driven by CSS `focus-within`, no JS state).
     */
    variant?: RichTextInputVariant;
};

export const RichTextInput = ({
    disableVoiceRecording,
    autoFocus = false,
    value,
    onChange,
    placeholder,
    className,
    contentClassName,
    error = false,
    variant = 'default',
}: RichTextInputProps): ReactElement => {
    return (
        <UIRichTextInput
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            theme={RICH_TEXT_THEME}
            nodes={RICH_TEXT_NODES}
            namespace="RichTextViewer"
            variant={variant}
            error={error}
            className={className}
            contentClassName={contentClassName}
        >
            <ToolbarPlugin
                disableVoiceRecording={disableVoiceRecording}
                className={variant === 'inline' ? 'hidden group-focus-within:flex' : undefined}
            />
            {autoFocus && <AutoFocusPlugin />}
        </UIRichTextInput>
    );
};
